import { render, staticRenderFns } from "./RequestDocumentDraft.vue?vue&type=template&id=f9cdb612&scoped=true"
import script from "./RequestDocumentDraft.vue?vue&type=script&lang=js"
export * from "./RequestDocumentDraft.vue?vue&type=script&lang=js"
import style0 from "./RequestDocumentDraft.vue?vue&type=style&index=0&id=f9cdb612&prod&lang=scss&scoped=true"
import style1 from "./RequestDocumentDraft.vue?vue&type=style&index=1&id=f9cdb612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cdb612",
  null
  
)

export default component.exports